export default function Upload() {
  return {}
}
